import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Course } from '../models/course.model';

@Injectable({
  providedIn: 'root'
})
export class CourseService {

  private baseUrl = environment.baseUrl;
  private courses: BehaviorSubject<Course[] | undefined> = new BehaviorSubject<Course[] | undefined>(undefined);

  constructor(private http: HttpClient) {}

  saveCourse(course: Course): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/courses/save`, { course: course });
  }

  updateCourse(course: Course): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/courses/update`, { course: course });
  }

  fetchCourses() {
    this.http.get<Course[]>(`${this.baseUrl}/courses`).subscribe((courses) => {
      this.courses.next(courses.map(course => Course.constructCourse(course)));
    });
  }

  getCourses(): Observable<Course[] | undefined> {
    return this.courses.asObservable();
  }

  getSmartRepetitionCourses(): Observable<Course[]> {
    return this.http.get<Course[]>(`${this.baseUrl}/courses/smart-repetition`);
  }

  getCourseNameById(courseId: number): string | undefined {
    return this.courses.getValue()?.find(course => course.id === courseId)!.name;
  }

  getCourse(courseId: string): Observable<Course[]> {
    return this.http.get<Course[]>(`${this.baseUrl}/courses/${courseId}`);
  }

  deleteCourse(courseId: number) {
    return this.http.delete<Course>(`${this.baseUrl}/courses/${courseId}`);
  }
}
